/**
 * Divider — Visual separator
 *
 * Variants:
 *   - orientation: horizontal (default), vertical
 */
import { styled, YStack } from 'tamagui'

export const Divider = styled(YStack, {
  name: 'Divider',
  bg: '$borderColor',
  h: 1,
  w: '100%',
  my: '$md',

  variants: {
    orientation: {
      horizontal: {
        h: 1,
        w: '100%',
        my: '$md',
        mx: 0,
      },
      vertical: {
        w: 1,
        h: 50,
        mx: '$sm',
        my: 0,
      },
    },
  } as const,

  defaultVariants: {
    orientation: 'horizontal',
  },
})
